export default [
  {
    path: '/home',
    name: 'admin-home',
    component: () => import('@/pages/main/home'),
    meta: {
      action: "read",
      pageTitle: 'Dashboard',
      resource: "AdminRoute",
      breadcrumb: [
        {
          text: 'Home',
          active: true,
        },
      ],
      roles: ["admin"],
      requireAuth: true,
      logPageName: "Admin Dashboard",
    },
  },
  /** Admin API */
  {
    path: '/api-keys',
    name: 'admin-api-keys',
    component: () => import('@/pages/main/api/list'),
    meta: {
      action: "read",
      pageTitle: 'API Keys',
      resource: "AdminBankAccessAPIRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'API Keys',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      logPageName: "Admin API Keys",
      permissions: ["api_keys:CanList"],
    },
  },
  {
    path: '/api-keys/new',
    name: 'new-api-keys',
    component: () => import('@/pages/main/api/new'),
    meta: {
      action: "read",
      pageTitle: 'New API Key',
      resource: "AdminBankAccessAPIRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'API Keys',
          to: { name: 'admin-api-keys' },
        },
        {
          text: 'New API Key',
          active: true,
        },
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["api_keys:CanAddNew"],
      logPageName: "Admin Create Bank API Key",
    },
  },
  {
    path: '/api-keys/:api_key_id/usage',
    name: 'admin-api-key-usage',
    component: () => import('@/pages/main/api/view'),
    meta: {
      action: "read",
      pageTitle: 'API Key Usage',
      resource: "AdminSettingsRoute",
      breadcrumb: [
        {
          text: 'API Keys',
          to: { name: 'admin-api-keys' },
        },
        {
          text: 'API Key Usage',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["api_key_usage:CanView"],
      logPageName: "Admin View API Key Usage",
    },
  },
  /** Admin Patients */
  {
    path: '/patients',
    name: 'admin-patients',
    component: () => import('@/pages/main/patients/list'),
    meta: {
      action: "read",
      pageTitle: 'Patients',
      resource: "AdminListPatientsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Patients',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Patients",
      showPagination: true,
      roles: ["admin"],
      permissions: ["patients:CanList"]
    },
  },
  {
    path: '/patients/:id',
    name: 'admin-patient-details',
    component: () => import('@/pages/main/patients/view'),
    meta: {
      action: "read",
      pageTitle: 'Patient Profile',
      resource: "patients",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Patients',
          to: { name: 'admin-patients' },
        },
        {
          text: 'Patient Profile',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["patients:CanView"],
      logPageName: "Admin View Patient Profile",
    },
  },
  {
    name: 'admin-update-patient',
    path: '/patients/:id/update',
    component: () => import('@/pages/main/patients/update'),
    resource: "patients",
    meta: {
      action: "read",
      pageTitle: 'Update Patient',
      resource: "AdminUpdateUserRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Patients',
          to: { name: 'admin-patients' },
        },
        {
          text: 'Update Patient Profile',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      logPageName: "Admin Update Patient Profile",
      permissions: ["patients:CanUpdate"]
    },
  },
  /** CONSULTATIONS */
  {
    path: '/consultations',
    name: 'admin-consultations',
    component: () => import('@/pages/main/medical-consultations/list'),
    meta: {
      action: "read",
      pageTitle: 'Consultations',
      resource: "AdminListConsultationsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Consultations',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Consultations",
      showPagination: true,
      roles: ["admin"],
      permissions: ["consultations:CanList"]
    },
  },
  {
    path: '/medical-consultations/:id/summary',
    name: 'admin-medical-consultation-summary',
    component: () => import('@/pages/main/medical-consultations/view'),
    meta: {
      action: "read",
      pageTitle: 'Medical Consultation Summary',
      resource: "consultations",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Consultations',
          to: { name: 'admin-consultations' },
        },
        {
          text: 'Medical Consultation Summary',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["consultations:CanView"],
      logPageName: "Admin View Medical Consultation Summary",
    },
  },
  {
    path: '/dietary-consultations/:id/summary',
    name: 'admin-dietary-consultation-summary',
    component: () => import('@/pages/main/dietary-consultations/view'),
    meta: {
      action: "read",
      pageTitle: 'Dietary Consultation Summary',
      resource: "consultations",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Consultations',
          to: { name: 'admin-consultations' },
        },
        {
          text: 'Dietary Consultation Summary',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["consultations:CanView"],
      logPageName: "Admin View Dietary Consultation Summary",
    },
  },
  {
    path: '/medical-consultations/:id/edit',
    name: 'admin-medical-consultation-edit',
    component: () => import('@/pages/main/medical-consultations/edit'),
    meta: {
      action: "read",
      pageTitle: 'Edit Medical Consultation',
      resource: "consultations",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Consultations',
          to: { name: 'admin-consultations' },
        },
        {
          text: 'Medical Consultation Summary',
          to: { name: 'admin-medical-consultation-summary' },
        },
        {
          text: 'Edit Medical Consultation',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["consultations:CanUpdate"],
      logPageName: "Admin Edit Medical Consultation",
    },
  },
  {
    path: '/dietary-consultations/:id/edit',
    name: 'admin-dietary-consultation-edit',
    component: () => import('@/pages/main/dietary-consultations/edit'),
    meta: {
      action: "read",
      pageTitle: 'Edit Dietary Consultation',
      resource: "consultations",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Consultations',
          to: { name: 'admin-consultations' },
        },
        {
          text: 'Dietary Consultation Summary',
          to: { name: 'admin-dietary-consultation-summary' },
        },
        {
          text: 'Edit Dietary Consultation',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["consultations:CanUpdate"],
      logPageName: "Admin Edit Dietary Consultation",
    },
  },

  /** APPOINTMENTS */
  {
    path: '/appointments',
    name: 'admin-appointments',
    component: () => import('@/pages/main/appointments'),
    meta: {
      action: "read",
      pageTitle: 'Appointments',
      resource: "AdminListAppointmentsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Appointments',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Appointments",
      showPagination: true,
      roles: ["admin"],
      permissions: ["appointments:CanList"]
    },
  },
  /** PHARMACIES */
  {
    path: '/pharmacies',
    name: 'admin-pharmacies',
    component: () => import('@/pages/main/pharmacies/list'),
    meta: {
      action: "read",
      pageTitle: 'Pharmacies',
      resource: "AdminListPharmaciesRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Pharmacies',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Pharmacies",
      showPagination: true,
      roles: ["admin"],
      permissions: ["pharmacies:CanList"]
    },
  },
  {
    path: '/pharmacies/:id',
    name: 'admin-pharmacy-details',
    component: () => import('@/pages/main/pharmacies/view'),
    meta: {
      action: "read",
      pageTitle: 'Pharmacy Overview',
      resource: "AdminViewPharmaciesRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Pharmacies',
          to: { name: 'admin-pharmacies' },
        },
        {
          text: 'Pharmacy Overview',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["pharmacies:CanView"],
      logPageName: "Admin View Pharmacy Overview",
    },
  },
  /* LABS */
  {
    path: '/labs',
    name: 'admin-labs',
    component: () => import('@/pages/main/labs/list'),
    meta: {
      action: "read",
      pageTitle: 'Labs',
      resource: "AdminListLabsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Labs',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Labs",
      showPagination: true,
      roles: ["admin"],
      permissions: ["labs:CanList"]
    },
  },
  {
    path: '/labs/:id',
    name: 'admin-lab-details',
    component: () => import('@/pages/main/labs/view'),
    meta: {
      action: "read",
      pageTitle: 'Lab Overview',
      resource: "AdminViewPharmaciesRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Labs',
          to: { name: 'admin-labs' },
        },
        {
          text: 'Lab Overview',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["labs:CanView"],
      logPageName: "Admin View Lab Overview",
    },
  },
  /** EXTERNAL REFERRALS */
  {
    path: '/external-referrals',
    name: 'admin-external-referrals',
    component: () => import('@/pages/main/external-referrals'),
    meta: {
      action: "read",
      pageTitle: 'External Referrals',
      resource: "AdminListExternalReferralsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'External Referrals',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List External Referrals",
      showPagination: true,
      roles: ["admin"],
      permissions: ["external_referrals:CanList"]
    },
  },
    /** EXCUSE DUTIES */
    {
      path: '/excuse-duties',
      name: 'admin-excuse-duties',
      component: () => import('@/pages/main/excuse-duties'),
      meta: {
        action: "read",
        pageTitle: 'Excuse Duties',
        resource: "AdminListExcuseDutiesRoute",
        breadcrumb: [
          {
            text: 'Home',
            to: { name: 'admin-home' },
          },
          {
            text: 'Excuse Duties',
            active: true,
          }
        ],
        requireAuth: true,
        logPageName: "Admin List Excuse Duties",
        showPagination: true,
        roles: ["admin"],
        permissions: ["excuse_duties:CanList"]
      },
    },

  /** ADMIN USERS */
  {
    path: '/administrators',
    name: 'admin',
    component: () => import('@/pages/main/administrators/list'),
    meta: {
      action: "read",
      pageTitle: 'Administrators',
      resource: "AdminListUsersRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'List Administrators',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["admin:CanList"],
      logPageName: "Admin List Administrators",
    },
  },
  {
    name: 'admin-single',
    path: '/administrators/:id',
    component: () => import('@/pages/main/administrators/update'),
    meta: {
      action: "read",
      pageTitle: 'User Details',
      resource: "admin",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'List Admins',
          to: { name: 'admin' },
        },
        {
          text: 'Admin Details',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["admin:CanView"],
      logPageName: "Admin User Details",
    },
  },
  {
    path: '/administrators/new',
    name: 'add-administrator',
    component: () => import('@/pages/main/administrators/new'),
    meta: {
      action: "read",
      pageTitle: 'Add Administrator',
      resource: "admin",
      breadcrumb: [
        {
          text: 'List Administrators',
          to: { name: 'admin' },
        },
        {
          text: 'New',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["admin:CanAddNew"],
      logPageName: "Admin Create Administrator",
    },
  },
  /** END OF ADMIN USERS */

  /** REPORTS  */
  {
    path: '/reports/consultations',
    name: 'admin-consultation-reports',
    component: () => import('@/pages/main/reports/consultation'),
    meta: {
      action: "read",
      pageTitle: 'Consultation Reports',
      resource: "AdminConsultationtReportsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Consultation Reports',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["consultation_reports:CanList"],
      logPageName: "Admin View Consultation Reports",
    },
  },
  {
    path: '/reports/patient',
    name: 'admin-patient-reports',
    component: () => import('@/pages/main/reports/patient'),
    meta: {
      action: "read",
      pageTitle: 'Patient Reports',
      resource: "AdminPatientReportsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Patient Reports',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["patients_reports:CanList"],
      logPageName: "Admin View Patient Reports",
    },
  },
  {
    path: '/reports/pharmacy',
    name: 'admin-pharmacy-reports',
    component: () => import('@/pages/main/reports/pharmacy'),
    meta: {
      action: "read",
      pageTitle: 'Pharmacy Reports',
      resource: "AdminPharmacyReportsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Pharmacy Reports',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["main_pharmacy_reports:CanList"],
      logPageName: "Admin View Pharmacy Reports",
    },
  },
  {
    path: '/reports/lab',
    name: 'admin-lab-reports',
    component: () => import('@/pages/main/reports/lab'),
    meta: {
      action: "read",
      pageTitle: 'Lab Facility Reports',
      resource: "AdminLabReportsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Lab Facility Reports',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["main_lab_reports:CanList"],
      logPageName: "Admin View Lab Reports",
    },
  },
  {
    path: '/reports/icd-10',
    name: 'admin-icd-10-reports',
    component: () => import('@/pages/main/reports/icd-10'),
    meta: {
      action: "read",
      pageTitle: 'ICD-10 Reports',
      resource: "AdminICD10ReportsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'ICD-10 Reports',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["icd_10_reports:CanList"],
      logPageName: "Admin View ICD 10 Reports",
    },
  },
  {
    path: '/reports/patients-seen',
    name: 'admin-patients-seen-reports',
    component: () => import('@/pages/main/reports/patients-seen'),
    meta: {
      action: "read",
      pageTitle: 'Reports',
      resource: "AdminReportsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Reports',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["patients_seen_reports:CanList"],
      logPageName: "Admin View Patients Seen Reports",
    },
  },
  {
    path: '/reports/medications',
    name: 'admin-medication-reports',
    component: () => import('@/pages/main/reports/medication'),
    meta: {
      action: "read",
      pageTitle: 'Medication Reports',
      resource: "AdminMedicationReportsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Medication Reports',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["medication_reports:CanList"],
      logPageName: "Admin View Medication Reports",
    },
  },

  /** Admin Settings */
  {
    path: '/settings',
    name: 'admin-settings',
    component: () => import('@/pages/main/settings'),
    meta: {
      action: "read",
      pageTitle: 'Settings',
      resource: "AdminSettingsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Settings',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["settings:CanView"],
      logPageName: "Admin View Settings",
    },
  },
  {
    path: '/policies',
    name: 'admin-policies',
    component: () => import('@/pages/main/administrations/policies/list-policies'),
    meta: {
      action: "read",
      pageTitle: 'Policies',
      resource: "AdminListPermissionsRoute",
      breadcrumb: [
        {
          text: 'List Policies',
          to: { name: 'admin-policies' },
        },
        {
          text: 'List',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["policy:CanList"],
      logPageName: "Admin List Policies",
      showPagination: true,
    },
  },
  {
    path: '/icd-10-codes',
    name: 'admin-icd-10-medical-codes',
    component: () => import('@/pages/main/icd-10-medical-codes'),
    meta: {
      action: "read",
      pageTitle: 'ICD-10 Medical Diagnosis Codes',
      resource: "AdminListICD10MedicalDiagnosisCodesRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'ICD-10 Medical Diagnosis Codes',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List ICD-10 Medical Diagnosis Codes",
      showPagination: true,
      roles: ["admin"],
      permissions: ["icd_10_diagnosis_codes:CanList"]
    },
  },
  {
    path: '/cancer-types',
    name: 'admin-cancer-types',
    component: () => import('@/pages/main/cancer-types'),
    meta: {
      action: "read",
      pageTitle: 'Cancer Types',
      resource: "AdminListCancerTypesRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Cancer Types',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Cancer Types",
      showPagination: true,
      roles: ["admin"],
      permissions: ["cancer_types:CanList"]
    },
  },
  {
    path: '/common-complaints',
    name: 'admin-common-complaints',
    component: () => import('@/pages/main/common-complaints'),
    meta: {
      action: "read",
      pageTitle: 'Common Complaints',
      resource: "AdminListCommonComplaintsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Common Complaints',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Common Complaints",
      showPagination: true,
      roles: ["admin"],
      permissions: ["common_complaints:CanList"]
    },
  },
  {
    path: '/direct-questions',
    name: 'admin-direct-questions',
    component: () => import('@/pages/main/direct-questions'),
    meta: {
      action: "read",
      pageTitle: 'Direct Questions',
      resource: "AdminListDirectQuestionsCodesRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Direct Questions',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Direct Questions",
      showPagination: true,
      roles: ["admin"],
      permissions: ["direct_questions:CanList"]
    },
  },
  {
    path: '/drugs',
    name: 'admin-drugs',
    component: () => import('@/pages/main/drugs'),
    meta: {
      action: "read",
      pageTitle: 'Drugs / Medications',
      resource: "AdminListDrugsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Drugs / Medications',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Drugs / Medications",
      showPagination: true,
      roles: ["admin"],
      permissions: ["drugs:CanList"]
    },
  },
  {
    path: '/drug/routes',
    name: 'admin-drug-routes',
    component: () => import('@/pages/main/drugs/routes'),
    meta: {
      action: "read",
      pageTitle: 'Drug Routes',
      resource: "AdminListDrugRoutesRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Drug Routes',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Drug Routes",
      showPagination: true,
      roles: ["admin"],
      permissions: ["drug_routes:CanList"]
    },
  },
  {
    path: '/drug/formulation',
    name: 'admin-drug-formulation',
    component: () => import('@/pages/main/drugs/formulations'),
    meta: {
      action: "read",
      pageTitle: 'Drug Formulations',
      resource: "AdminListDrugFormulationsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Drug Formulations',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Drug Formulations",
      showPagination: true,
      roles: ["admin"],
      permissions: ["drug_formulations:CanList"]
    },
  },
  {
    path: '/drug/concentration',
    name: 'admin-drug-concentration',
    component: () => import('@/pages/main/drugs/concentrations'),
    meta: {
      action: "read",
      pageTitle: 'Drug Concentrations',
      resource: "AdminListDrugConcentrationsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Drug Concentrations',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Drug Concentrations",
      showPagination: true,
      roles: ["admin"],
      permissions: ["drug_concentrations:CanList"]
    },
  },
  {
    path: '/drug/dose-frequency',
    name: 'admin-drug-dose-frequency',
    component: () => import('@/pages/main/drugs/dose-frequency'),
    meta: {
      action: "read",
      pageTitle: 'Drug Dose Frequency',
      resource: "AdminListDrugDoseFrequencyRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Drug Dose Frequency',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Drug Dose Frequency",
      showPagination: true,
      roles: ["admin"],
      permissions: ["drug_dose_frequency:CanList"]
    },
  },

  /* LAB SETTINGS */
  {
    path: '/lab-types',
    name: 'admin-lab-types',
    component: () => import('@/pages/main/lab-types'),
    meta: {
      action: "read",
      pageTitle: 'Lab',
      resource: "AdminListLabsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Labs',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Lab Settings",
      showPagination: true,
      roles: ["admin"],
      permissions: ["lab_types:CanList"]
    },
  },
  {
    path: '/lab-categories',
    name: 'admin-lab-categories',
    component: () => import('@/pages/main/lab-categories'),
    meta: {
      action: "read",
      pageTitle: 'Lab Categories',
      resource: "AdminListLabCategoriesRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Lab Categories',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Lab Categories",
      showPagination: true,
      roles: ["admin"],
      permissions: ["lab_categories:CanList"]
    },
  },
  /* Partners */
  {
    path: '/partners',
    name: 'admin-partners',
    component: () => import('@/pages/main/partners'),
    meta: {
      action: "read",
      pageTitle: 'Partners',
      resource: "AdminPartnersRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Partners',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Partners",
      showPagination: true,
      roles: ["admin"],
      permissions: ["consultations:CanList"]
    },
  },

  /** Admin Permission Policies */
  {
    path: '/policies/:id',
    name: 'admin-view-policies',
    component: () => import('@/pages/main/administrations/policies/view-policy'),
    meta: {
      action: "read",
      pageTitle: 'Policy',
      resource: "policy",
      breadcrumb: [
        {
          text: 'List Policies',
          to: { name: 'admin-policies' },
        },
        {
          text: 'View',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["policy:CanView"],
      logPageName: "Admin View Policies",
    },
  },
  {
    path: '/create-policy',
    name: 'admin-new-policy',
    component: () => import('@/pages/main/administrations/policies/new-policy'),
    meta: {
      action: "read",
      pageTitle: 'Add Policy',
      resource: "AdminListPermissionsRoute",
      breadcrumb: [
        {
          text: 'List Policies',
          to: { name: 'admin-policies' },
        },
        {
          text: 'New',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["policy:CanAddNew"],
      logPageName: "Admin Create Policy",
    },
  },

  /** Admin Permission Resource */
  {
    path: '/resources',
    name: 'admin-resources',
    component: () => import('@/pages/main/administrations/resources/list-resources'),
    meta: {
      action: "read",
      pageTitle: 'Resources',
      resource: "AdminListPermissionsRoute",
      breadcrumb: [
        {
          text: 'List Resources',
          to: { name: 'admin-resources' },
        },
        {
          text: 'List',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["resource:CanList"],
      logPageName: "Admin List Resources",
    },
  },
  {
    path: '/create-resource',
    name: 'admin-new-resource',
    component: () => import('@/pages/main/administrations/resources/new-resource'),
    meta: {
      action: "read",
      pageTitle: 'Resource',
      resource: "AdminListPermissionsRoute",
      breadcrumb: [
        {
          text: 'Resources',
          to: { name: 'admin-resources' },
        },
        {
          text: 'Add Resource',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      logPageName: "Admin New Resources",
      permissions: ["resource:CanAddNew"],
    },
  },
  {
    path: '/update-resource/:id',
    name: 'admin-update-resource',
    component: () => import('@/pages/main/administrations/resources/update-resource'),
    meta: {
      action: "read",
      pageTitle: 'Resource',
      resource: "resource",
      breadcrumb: [
        {
          text: 'Resources',
          to: { name: 'admin-resources' },
        },
        {
          text: 'Update Resource',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["resource:CanView"],
      logPageName: "Admin Update Resources",
    },
  },

  /** Admin Permission Resource Actions */
  {
    path: '/resource-actions',
    name: 'admin-resource-actions',
    component: () => import('@/pages/main/administrations/resource-actions/list-resource-actions'),
    meta: {
      action: "read",
      pageTitle: 'Resource Actions',
      resource: "AdminListPermissionsRoute",
      breadcrumb: [
        {
          text: 'List Resource Actions',
          to: { name: 'admin-resource-actions' },
        },
        {
          text: 'List',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["resource_action:CanList"],
      logPageName: "Admin List Resource Actions",
    },
  },
  {
    name: 'admin-new-resource-action',
    path: '/create-resource-action/:id',
    component: () => import('@/pages/main/administrations/resource-actions/new-resource-action'),
    meta: {
      action: "read",
      pageTitle: 'Add Resource Action',
      resource: "AdminListPermissionsRoute",
      breadcrumb: [
        {
          text: 'Resource Actions',
          to: { name: 'admin-resource-actions' },
        },
        {
          text: 'Add Resource Action',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      logPageName: "Admin Add Resource Actions",
      permissions: ["resource_action:CanView"],
    },
  },
  {
    name: 'admin-update-resource-action',
    path: '/update-resource-action/:id/:resource_id',
    component: () => import('@/pages/main/administrations/resource-actions/update-resource-action'),
    meta: {
      action: "read",
      pageTitle: 'Resource Action',
      resource: "resource_action",
      breadcrumb: [
        {
          text: 'Resources',
          to: { name: 'admin-resources' },
        },
        {
          text: 'Update Resource Action',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["resource_action:CanView"],
      logPageName: "Admin Update Resource Action",
    },
  },

  /** Admin Permission User Roles */
  {
    path: '/user-roles',
    name: 'admin-user-roles',
    component: () => import('@/pages/main/administrations/user-roles/list'),
    meta: {
      action: "read",
      pageTitle: 'User Role',
      resource: "AdminListPermissionsRoute",
      breadcrumb: [
        {
          text: 'List User Roles',
          to: { name: 'admin-user-roles' },
        },
        {
          text: 'List',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["user_role:CanList"],
      logPageName: "Admin List User Roles",
    },
  },
  {
    path: '/create-user-role',
    name: 'admin-new-user-role',
    component: () => import('@/pages/main/administrations/user-roles/new-user-role'),
    meta: {
      action: "read",
      pageTitle: 'Add Admin User Role',
      resource: "user_role",
      breadcrumb: [
        {
          text: 'User Roles',
          to: { name: 'admin-user-roles' },
        },
        {
          text: 'Add Admin User Role',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      logPageName: "Add Admin User Role",
      permissions: ["user_role:CanAddNew"],
    },
  },
  {
    path: '/update-user-role/:id',
    name: 'admin-update-patient-role',
    component: () => import('@/pages/main/administrations/user-roles/update-user-role'),
    meta: {
      action: "read",
      pageTitle: 'Add Admin User Role',
      resource: "user_role",
      breadcrumb: [
        {
          text: 'User Roles',
          to: { name: 'admin-user-roles' },
        },
        {
          text: 'Update Admin User Role',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      permissions: ["user_role:CanView"],
      logPageName: "Update Admin User Role",
    },
  },

  // Admin Logs
  {
    path: '/admin-logs',
    name: 'admin-logs',
    component: () => import('@/pages/main/logs/admin'),
    meta: {
      action: "read",
      pageTitle: 'Admin Logs',
      resource: "AdminListAdminLogsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Admin Logs',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["admin_logs:CanList"],
      logPageName: "Admin List Logs",
    },
  },
  {
    path: '/user-logs',
    name: 'user-logs',
    component: () => import('@/pages/main/logs/user'),
    meta: {
      action: "read",
      pageTitle: 'User Logs',
      resource: "AdminListLogsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'User Logs',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["logs:CanList"],
      logPageName: "User List Logs",
    },
  },
  {
    path: '/audit-trail',
    name: 'audit-trail',
    component: () => import('@/pages/main/logs/audit-trail'),
    meta: {
      action: "read",
      pageTitle: 'Audit Trail',
      resource: "AdminListLogsRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Audit Trail',
          active: true,
        }
      ],
      roles: ["admin"],
      requireAuth: true,
      showPagination: true,
      permissions: ["audit_trail:CanList"],
      logPageName: "List Audit Trail",
    },
  },
  /** NOTIFICAITONS */
  {
    path: '/notifications',
    name: 'admin-notifications',
    component: () => import('@/pages/main/notifications'),
    meta: {
      pageTitle: 'Notifications',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'admin-home' },
        },
        {
          text: 'Notifications',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Notifications",
      showPagination: true,
      roles: ["admin"],
      permissions: ["notifications:CanList"]
    },
  },
]

